<template>
  <div class="app">
    <div class="Edit-base">
      <div class="title">编辑自我介绍</div>
      <div class="Edit-content">
        <div class="content-box">
          <div class="box-item">
            <div class="item-title">自我介绍</div>
            <div class="item-content">
              <el-input type="textarea" :autosize="{ minRows: 8, maxRows: 4 }" placeholder="请输入内容"
                v-model="post.myself">
              </el-input>
              <div class="item-content btn">
                <el-button @click="cancel">取消</el-button>
                <el-button type="primary" @click="save">保存</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updateMyself } from '@/request/api'
export default {
  props: {
    val: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      post: {
        ID: '',
        username: '',
        myself: ''
      }
    }
  },
  created() {
    this.post.ID = this.val.id;
    this.post.username = JSON.parse(sessionStorage.getItem('LoginInfo')).username
    this.post.myself = this.val.selfIntroduce.replace(/<br\/>/g, '\n');;
  },
  methods: {
    cancel() {
      this.$emit("myselfShow", false);
    },
    textBetween(str, left_key, right_key) {
      var g_left = str.indexOf(left_key);
      if (g_left != -1) {
        g_left = g_left + left_key.length;
        var g_right = str.indexOf(right_key, g_left);
      }
      if (g_right != -1) {
        return str.substr(g_left, g_right - g_left);
      }
    },
    isPostDataEmpty(post) {
      // 检查 post 对象中的每个属性是否为空
      for (let key in post) {
        if (post.hasOwnProperty(key) && post[key] === '') {
          // 如果发现空属性，返回 true
          return true;
        }
      }
      // 如果所有属性都不为空，返回 false
      return false;
    },
    async save() {
      if (this.isPostDataEmpty(this.post)) {
        this.$message.error('请填写完整信息');
        return;
      }
      this.post.ID = this.textBetween(this.$route.fullPath, 'resumeID=', '&timestamp');
      const { data: res } = await updateMyself(this.post);
      this.$emit("myselfShow", true);
    }
  }
}
</script>

<style lang="scss" scoped>
.app {
  background: #fff;
  padding: 20px;

  .Edit-base {
    background: #f4f5fb;
    padding: 20px;
    box-sizing: border-box;

    .title {
      font-size: 18px;
      color: #333;
      margin-bottom: 20px;
    }

    .Edit-content {
      .content-box {
        .item-title {
          font-size: 16px;
          color: #333;
          line-height: 40px;
        }

        .btn {
          display: flex;
          padding-top: 20px;
          justify-content: flex-end;
          align-items: center;

          .el-button {
            width: 24%;
          }
        }
      }
    }
  }
}
</style>